import { map } from 'rxjs';
import { Component, EventEmitter, Inject, Input, LOCALE_ID, Output, SimpleChanges } from '@angular/core';
import { BonusInfo } from 'src/app/services/payment/bonus/bonus.models';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { TeaserTopMobileComponent } from 'src/app/components/teaser-top-mobile/teaser-top-mobile.component';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { Apollo } from 'apollo-angular';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { Router } from '@angular/router';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { ChargebackService } from 'src/app/services/profile/chargeback.service';
import { BonusLotteryService } from 'src/app/services/profile/bonuslottery.service';
import { LICENCE } from 'src/app/global.tokens';

interface Teaser {
  msg: string
  countDown: {
    minutes: string,
    seconds: string
  }
}

@Component({
  selector: 'app-deposit-bonus-selector',
  templateUrl: './deposit-bonus-selector.component.html',
  styleUrls: ['./deposit-bonus-selector.component.scss']
})
export class DepositBonusSelectorComponent extends TeaserTopMobileComponent {

  @Input()
  set bonusList(bonusListInput: BonusInfo[]) {
    if (bonusListInput) {
      this._bonusList = bonusListInput;
    }
  }
  get bonusList(): BonusInfo[] {
    return this._bonusList;
  }



  private _bonusList: BonusInfo[];
  isBonusActivated: boolean = false;
  private _selectedBonus: BonusInfo;
  teaserData: Teaser;


  @Input() set selectedBonus(value: BonusInfo) {
    this._selectedBonus = value;
    this.isBonusActivated = !!value && value?.externalId !== this.NULL_BONUS;
  };

  get selectedBonus(): BonusInfo {
    return this._selectedBonus;
  }
  @Input() isReady: boolean;
  @Output() selectedTeaser = new EventEmitter<Teaser>();

  NULL_BONUS = "0";

  constructor(
    protected loginStatusService: LoginStatusService,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(LICENCE) public licence: string,
    protected apollo: Apollo,
    protected router: Router,
    protected translationConfig: TranslationConfig,
    protected detectDesktopService: DetectDeviceService,
    protected licenceService: LicenceService,
    protected chargebackService: ChargebackService,
    protected bonusLotteryService: BonusLotteryService,


  ) {
    super(
      loginStatusService,
      locale,
      licence,
      apollo,
      router,
      translationConfig,
      chargebackService,
      bonusLotteryService,
      licenceService
    )
  }

  ngOnInit(): void {
    this.isDesktop = this.detectDesktopService.isDesktop();
    this.getData();

  }

  ngAfterViewInit(): void {
    const teaserData: Teaser = {
      msg: this.teaser?.msg || null,
      countDown: this.countDown || null
    }

    console.log('teaserDatatosent', teaserData, this.teaser, this.countDown);

    this.selectedTeaser.next(teaserData);
  }
}
